import React from 'react'
import { AppContext } from '../../App'
import { Navigate } from 'react-router-dom'

export enum OnboardingStep {
	ConnectXPM = 0,
	ConnectXeroBlue = 1,
	GeneralSettings = 2,
	GradeSettings = 3,
	StaffSettings = 4,
}

const stepRoutes: Record<OnboardingStep, string> = {
	[OnboardingStep.ConnectXPM]: '/xero/connections',
	[OnboardingStep.ConnectXeroBlue]: '/xero/connections',
	[OnboardingStep.GeneralSettings]: '/accountSettings',
	[OnboardingStep.GradeSettings]: '/accountSettings#grade',
	[OnboardingStep.StaffSettings]: '/accountSettings#staff',
}

const Onboarding = () => {
	const { appState } = React.useContext(AppContext)

	// Use appState if available, otherwise fallback to localStorage
	const stepFromContext = appState.onBoardingStep
	const stepFromStorage = localStorage.getItem('onBoardingStep')

	let targetStep: OnboardingStep | null = null

	if (stepFromContext !== null && stepFromContext !== undefined) {
		targetStep = Number(stepFromContext) as OnboardingStep
	} else if (stepFromStorage !== null) {
		targetStep = Number(stepFromStorage) as OnboardingStep
	}

	const targetRoute = targetStep !== null && Object.prototype.hasOwnProperty.call(stepRoutes, targetStep) ? stepRoutes[targetStep] : '/'

	return <Navigate to={targetRoute} />
}

export default Onboarding
